const asyncActionType = type => ({
    pending: `${type}_PENDING`,
    success: `${type}_SUCCESS`,
    error: `${type}_ERROR`
});

export const LOAD_SETTINGS = asyncActionType('LOAD_SETTINGS');
export const SET_SETTINGS= asyncActionType('SET_SETTINGS');
export const EDIT_GENERAL_SETTINGS = asyncActionType('EDIT_GENERAL_SETTINGS');
export const EDIT_CALENDER_SETTINGS = asyncActionType('EDIT_CALENDER_SETTINGS');
export const EDIT_NOTIFICATION_SETTINGS = asyncActionType('EDIT_NOTIFICATION_SETTINGS');
export const EDIT_INVOICES_SETTINGS = asyncActionType('EDIT_INVOICES_SETTINGS');
